import { Lead } from "@mapmycustomers/shared/types/entity";
import { EntityPin, MultiPin } from "@mapmycustomers/shared/types/map";

import { RulerPoint } from "@app/types/map/RulerPath";
import { leadIdGetter } from "@app/util/map/idGetters";

export const getRulerPinId = (pin: RulerPoint["pin"]) =>
  !pin
    ? undefined
    : "place_id" in pin
      ? leadIdGetter(pin as Lead)
      : (pin as EntityPin | MultiPin).id;
